export const setSessionStorage = value =>
  window.sessionStorage.setItem('token', value)
export const getSessionStorage = () => window.sessionStorage.getItem('token')
export const clearSessionStorage = () =>
  window.sessionStorage.removeItem('token')



// WEBPACK FOOTER //
// ./src/services/setSessionStorage.js